import RedHeartIcon from "@/User/Assets/Svgs/RedHeartIcon.svg";
import WhiteButton from "@/User/Components/Buttons/WhiteButton";
import { RouteName } from "@/User/Constants/routes";
import { Link } from "@inertiajs/react";
import classNames from "classnames";
import React from "react";
import route from 'ziggy-js';
import { CategoriesArticleItems } from "../Utils/CategoriesArticleUtils";
import { LazyLoadImage } from "react-lazy-load-image-component";

const ArticleCard = ({ article }) => {
    const articleCategory = CategoriesArticleItems.find((value) => value.id === article.categories);

    return (
        <div className="inline-flex w-full flex-col relative bg-white border border-pattens-blue shadow-lg rounded-lg overflow-hidden cursor-pointer mt-4">
            <Link href={route(RouteName.ArticleDetailPage, { category: articleCategory.route, id: article.id })}>
                <div className="mx-4 mb-4">
                    <WhiteButton
                        className="!px-2 !py-1 mt-4"
                        textClass="text-white text-xs leading-3.5"
                        isRounded={true}
                        roundedClass="rounded"
                        bgClass="bg-jellyfish-3"
                    >
                        <span className="leading-3">{articleCategory.content}</span>
                    </WhiteButton>
                    <h4 className="font-semibold text-midnight mt-2 leading-5 h-10 line-clamp-2 break-all">{article.title}</h4>
                    <div className={classNames('flex mt-1',
                        {
                            'justify-between': article.favorite_articles_count !== 0,
                            'justify-end': article.favorite_articles_count === 0
                        }
                    )}>
                        {article.favorite_articles_count !== 0 && (
                            <div className="flex">
                                <LazyLoadImage
                                    src={RedHeartIcon}
                                    alt="Red Heart Icon"
                                    className="px-0.5 size-5"
                                />
                                <span className="text-free-speech-red text-sm ml-1 leading-6">{article.favorite_articles_count}</span>
                            </div>
                        )}
                        <span className="text-sm leading-6">{article.updated_at}</span>
                    </div>
                    <div className="flex mt-2 h-20.25">
                        <div className="h-20.25 max-w-36">
                            <LazyLoadImage
                                src={article.eyecatch_image}
                                className="size-full object-contain"
                                alt={article.title}
                            />
                        </div>
                        <div className="flex flex-col w-full">
                            <p className="text-sm pl-2 h-16.25 leading-5.25 line-clamp-3 break-all">{article.description}</p>
                            <div className="text-right h-4.5 leading-5">
                                <p className="text-xs text-primary underline">続きを読む</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default ArticleCard;
